package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_04_11_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes in Highridge, where demons and giants have invaded and driven the inhabitants fleeing to nearby Kostigan. The heroes see something large and fiery approaching through the smoke to the west.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Through the smoke runs a huge demon holding a whip in one hand and a sword in the other. Dirk takes cover behind a cart. The Balor tries to attack Tuesday, but Tuesday fools the demon with a mirror image. The Balor whips Falorn, dragging him after the initial strike. Annette tries to burn the Balor with Scorching Ray, but it is immune to fire damage. Falorn and Tuesday have better luck damaging the demon using radiant and acid damage.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth runs into a nearby building — he has a wild look on his face. Only a madman would leap off of a roof onto a flaming demon. But the demon charges at Bigglesworth and strikes before he is able to execute his leaping attack.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The demon lands several powerful blows but is ultimately outnumbered and attempts to flee. Annette’s ant cannon shoots him in the back, killing him.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In the quiet after the battle ends, the heroes hear struggling in a nearby building, where they find Mayor Roneth Grude bound with rope. Bigglesworth unties him, and the heroes assure him that his wife Lily is safe in Kostigan. Roneth tells the heroes that the demons were looking for a relic and for dark elves. Roneth gives the heroes a diamond as a reward for saving Highridge. The people of Highridge received the gem from the elves of the Gideon forest after assisting them in a battle against giants.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The arrival of giants and ettin in Highridge is puzzling, as these creatures normally live in the mountains, the nearest of which are far to the west — the mountainous source of the Shallabas River.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper insists on dragging the bodies of the fallen giants and ettin out of the city.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" When Dirk said he takes cover “behind the cart again,” Caper misheard him saying “being the cardigan.”")
        }
    }
}
